import type { ReactNode } from 'react';
import { FilterChips, type FilterChip } from './filter-chips';

export interface FilterBarProps {
  /** Applied 투영 칩 — 0개면 좌측이 빈 채로 트레일링만 우측 정렬된다(`FilterChips` 자체가 null 반환). */
  chips: FilterChip[];
  /** 트레일링 슬롯 — 통상 `Toolbar`(조회조건 트리거 + 초기화 + 페이지 액션). */
  children?: ReactNode;
}

/**
 * c영역 필터 행 — **칩(좌, 남는 폭 전부) + 트레일링 슬롯(우)** 한 줄. 조회조건 트리거와 그 결과(칩)를 한 시선에 묶는다.
 *
 * 트레일링을 `Toolbar` 로 고정하지 않고 **슬롯(children)** 으로 여는 이유: 툴바가 필터와 무관한 페이지 액션
 * (다운로드·갱신·등록)도 싣기 때문에, 소유해버리면 그 액션들을 전부 이 컴포넌트로 pass-through 해야 한다.
 *
 * ⚠️ 칩 슬롯의 `min-w-0` 이 **칩 말줄임의 전제 조건**이다 — flex item 의 자동 최소 크기(`min-width:auto`
 * = 콘텐츠 폭)가 `max-width` 보다 우선이라, 풀어주지 않으면 슬롯이 칩 내용만큼 벌어져 안쪽 `truncate` 가
 * 영영 발동하지 않는다. 클리핑(`overflow-hidden`)은 불필요 — 칩이 제 폭 안에서 말줄임되므로 샐 것이 없다.
 */
export function FilterBar({ chips, children }: FilterBarProps) {
  return (
    <div className="flex items-center gap-1">
      <div className="min-w-0 flex-1">
        <FilterChips chips={chips} />
      </div>
      {children}
    </div>
  );
}
